import axiosInstance from "./axiosInstance";
import useSWR from "swr";

export async function getTags() {
  return await axiosInstance.get("/tag");
}

export function useTags() {
  return useSWR("/tag");
}

export async function renameTag(name, newName) {
  return await axiosInstance.put(`/tag/${encodeURIComponent(name)}`, {
    newName,
  });
}

export async function deleteTag(name) {
  return await axiosInstance.delete(`/tag/${encodeURIComponent(name)}`);
}

export async function mergeTags(from, into) {
  return await axiosInstance.post("/tag/merge", { from, into });
}
